import React from 'react';
import { connect } from 'tanok';
import {
    BESIDA_ROLE_BUYER
} from '@evo/chat-core';

import { toJS } from '../../../../../helpers/ImmutableToJS';

import { ClientDisableChat } from './../../../../../ui/notification/client';
import { CompanyDisableChat } from './../../../../../ui/notification/company';

const DisableChatNotificationView = ({ userRole }) => {
    const isInBuyerRole = userRole === BESIDA_ROLE_BUYER;
    return isInBuyerRole ? <ClientDisableChat /> : <CompanyDisableChat />;
}

const mapStateToProps = (state) => {
    return {
        userRole: state.get('userRole'),
        locale: state.get('locale')
    };
};

export const DisableChatNotification = connect(mapStateToProps)(toJS(DisableChatNotificationView));
